import AbstractConfig from "../../../core/config/AbstractConfig";
import MapCharacterDefinition from "./MapCharacterDefinition";
import MapDefinition from "./MapDefinition";
import MapLocationDefinition from "./MapLocationDefinition";

export default class MapsConfig extends AbstractConfig {
    constructor() {
        super();

        this._memoizedMaps = null;
    }

    /**
     * @returns {Array<MapDefinition>}
     */
    get maps() {
        if (this._memoizedMaps) {
            return this._memoizedMaps;
        }

        const mapsObj = this.getValue('maps');

        const mapDefinitions = [];
        for (const [key, value] of Object.entries(mapsObj)) {
            const mapDefinition = new MapDefinition(
                key,
                value?.movieClipName,
                value?.locations?.map(n => new MapLocationDefinition(n.id, n.instanceName, n.imageId)),
                value?.characters?.map(n => new MapCharacterDefinition(n.id, n.location, n.imageId))
            );
            mapDefinitions.push(mapDefinition);
        }

        this._memoizedMaps = mapDefinitions;
        return this._memoizedMaps;
    }

    getMapById(mapId) {
        return this.maps.find(m => m.id === mapId);
    }

    getMapByChapterWeek(chapter, week) {
        if (week === undefined) {
            week = 1;
        }
        for (let i = this.maps.length - 1; i >= 0; i--) {
            const obj = this.maps[i];
            if (obj.id.startsWith("chapter_" + chapter)) {
                if (obj.id == "chapter_" + chapter) {
                    return obj;
                } else {
                    const match = obj.id.match(/chapter_(\d+)w(\d+)/);
                    if (match && match.length == 3) {
                        const objWeek = parseInt(match[2]);
                        if (objWeek <= week) {
                            return obj;
                        }
                    }
                }
            }
        }
    }
}
